import { FC, PropsWithChildren } from "react";
import { Stack } from "@mui/material";
import { ChatBot } from "@ob/core";
import { Body } from "../Body";
import { Footer } from "../Footer";
import { Header } from "../Header";

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack className="page--layout" direction="column" minHeight="100%">
      <Header />
      <Body>{children}</Body>
      <ChatBot hideOnMobile />
      <Footer />
    </Stack>
  );
};
